<template>
  <el-image
      :style="{width: size, height: size}"
      :src="images.headImg"
      @click="showImg(images.headImg)"
      class="cursor"
  >
  <template #error><div class="el-img-error">暂无图片</div></template></el-image>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";

export default {
name: "HeadImg",
  props: {
    images: {
      type: Object,
      default: {}
    },
    size: {
      type: String,
      default: '80px'
    },
  },
  data() {
    return {

    }
  },
  methods: {
    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },
  }
}
</script>

<style scoped>

</style>
